import { Card, CardBody, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ImStarFull } from "react-icons/im";
import { HiPhone } from "react-icons/hi2";
import { MdEmail } from "react-icons/md";
import { RiMapPin2Line } from "react-icons/ri";
import SessionUtil from '../util/SessionUtil';


function CardUser({ data,statusTrack }) {
    const { t } = useTranslation();
    const lang = SessionUtil.getLang();

    const getLocation = (location,city, index) => {
        const htmlCode = <div className='flex-gap-2 time-line-style before align-items-start'>

            {index === '0' ? <div className='circle-border'>
                <div className={`circle bg-primary`}></div>
            </div> :
                <RiMapPin2Line size={20} color='#0077B6' />
            }
            <div className='time-line-content'>
                <Card.Text className='mb-0'>{location}</Card.Text>
                <Card.Text className='mb-2 subtitle'>{t(city)}</Card.Text>
            </div>
        </div>

        return htmlCode;
    }
    return (
        <Card className='border-0 rounded-24 card-custome mb-5 card-user'>
            <CardBody className='px-0'>
                <div className='flex-gap-2 justify-content-between border-bottom pb-3 px-3'>
                    <div className='flex-gap-2'>
                        <div className='dimension-40 border rounded-pill'>
                            {data?.DriverImage ? <Image alt="image" src={data.DriverImage} width={20} height={20} className='img-fluid rounded-pill object-fit-initial' />
                                : <div className="img-empty rounded-pill"></div>
                            }
                        </div>
                        <div>
                            <p className='mb-0 fw-medium'>{lang === 'en' || data.DriverNameAr === "" ? data?.DriverNameEn : data?.DriverNameAr}</p>
                            <p className='subtitle mb-0 font-12'>#{data.OrderId}</p>
                        </div>
                    </div>
                    <div className='d-flex gap-1'><ImStarFull size={18} color={data.Rating > '0' ? "#EEAE0B" : "#E9E9EC"} /> <span className='font-12'>{data?.Rating > 0 ? data.Rating : ''}</span></div>
                </div>
                {/* ==================================================== */}
                <div className='border-bottom px-3 pt-3'>
                    <div className="flex-gap-2">
                        <HiPhone size={16} color={"#3A974C"} /> <p className="mb-0 subtitle font-12">{t('Phone Number')} :</p>
                    </div>
                    <p className='fw-medium'>{'+' + data.AreaCode + '' + data.PhoneNumber}</p>

                    <div className="flex-gap-2">
                        <MdEmail size={16} color={"#4285F4"} /> <p className="mb-0 subtitle font-12">{t('Email')} :</p>
                    </div>
                    <p className='fw-medium'>{data.Email}</p>
                </div>
                {/* ==================================================== */}
                {data.StoreLocation && data.UserAddress && <div className='border-bottom px-3 py-3'>
                    {getLocation('From Location',data.StoreLocation , '0')}
                    {getLocation('To Location',data.UserAddress,'1')}
                </div>}


                {/* ==================================================== */}
                <div className='flex-gap-2 justify-content-around px-4 pt-4 pb-2'>
                    <p className='mb-0'>{t('Status')} : </p>
                    {data.Status === 'ONLINE' ?
                        <div className="status py-2 status-success">{t('Online')}</div> :
                        data.Status === 'OFLINE' ?
                            <div className="status py-2 status-failed">{t('Offline')}</div>
                            :
                            <div className="status py-2 status-warning">{statusTrack ? t(statusTrack) : t(data.Status)}</div>}
                </div>
            </CardBody>
        </Card>
    )
}

export default CardUser;